import useResource from 'util/resource/useResource';
import { conversationApiUrls, UserConversation } from './conversationApi';
import config from 'config';

export const useConversationById = (conversationId?: UUID) => {
  const key = conversationId ? `${config.COMPANIES_API_URL}/conversations/${conversationId}` : undefined;
  return useResource<UserConversation>(key);
};

export const useConversationByUsers = (userIds: UUID[]) => {
  const key = userIds.length > 0 ? conversationApiUrls.user.getByUsers(userIds) : undefined;
  return useResource<UserConversation>(key);
};
